import type { ReactNode } from 'react'
import { REACTION_EMOJIS } from '@mote/helpers/constants'
import { StyledDropdown, StyledDropdownItem } from './ReactionPicker.styles'

export interface ReactionPickerProps {
  onChange: (value: string) => void
  triggerElement: ReactNode
  placement?:
    | 'top-left'
    | 'top-right'
    | 'top-center'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center'
}

/*
 * TODO: Add tooltip to the reactions
 */
export function ReactionPicker(props: ReactionPickerProps): JSX.Element {
  function handleSelection(value: number): void {
    props.onChange(REACTION_EMOJIS[value].value)
  }

  return (
    <StyledDropdown
      id='reaction-mote-picker'
      onAction={handleSelection}
      triggerElement={props.triggerElement}
      placement={props.placement || 'top-center'}
      showChevron={false}
      aria-label='Emoji reactions'
      orientation='horizontal'
      trigger='hover'
    >
      {REACTION_EMOJIS.map((reaction, index) => {
        return (
          <StyledDropdownItem key={index} aria-label={reaction.label}>
            {reaction.emoji}
          </StyledDropdownItem>
        )
      })}
    </StyledDropdown>
  )
}
